type TimeframeButtonProps = {
  value: string
  onChange: (value: string) => void
  isSelected: boolean
}

export default function TimeframeButton({ value, onChange, isSelected }: TimeframeButtonProps) {
  return (
    <button
      onClick={() => onChange(value)}
      className={`
        px-3 py-1 text-sm font-medium rounded-md transition-colors
        ${
          isSelected
            ? 'bg-gray-700 text-kodiak-brand-light'
            : 'bg-transparent text-gray-400 hover:text-white hover:bg-gray-800'
        }
      `}
    >
      {value}
    </button>
  )
}
